export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ');
};

/** Inverts an API exchange rate; returns '1' for invalid, zero, or negative input so amounts stay unchanged. */
export function invertExchangeRate(rate: number | string): string {
  const num = typeof rate === 'number' ? rate : parseFloat(String(rate));
  if (Number.isFinite(num) && num > 0) {
    return (1 / num).toString();
  }
  return '1';
}

/**
 * Formats a number to a string with a apostrophe as the thousands separator and a dot as the decimal separator.
 * forces 2 decimals
 * @param number
 * @returns string
 */
export const numberFormatter = (number: number) =>
  Intl.NumberFormat('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .format(number)
    .toString()
    // eslint-disable-next-line
    .replace(/,/g, "'");

/**
 * Formats a number to a string with a apostrophe as the thousands separator and a dot as the decimal separator.
 * @param number
 * @returns string
 */
export const numberFormatterChart = (number: number) =>
  Intl.NumberFormat('de-CH')
    .format(number)
    .toString()
    // eslint-disable-next-line
    .replace(/,/g, "'");

/**
 * Formats a date string to a date and time string by timezone
 * @param date
 * @param timeZone
 * @returns { date: string, time: string }
 */
export const getDateTimeByTimeZone = (dateString: string) => {
  const isoString = dateString.replace(' ', 'T') + '.000Z';
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const madeOnTimezone = new Date(isoString).toLocaleString('de-DE', { timeZone });
  const date = madeOnTimezone.split(',')[0];
  const time = madeOnTimezone.split(',')[1]?.slice(0, -3);
  return { date, time };
};

interface LockableTransaction {
  transaction_id?: string | null;
  parent_transaction_uuid?: string | null;
  has_splits?: boolean;
}

/**
 * Checks if a transaction is locked for editing (e.g. from Saltedge, split, or parent)
 * @param transaction
 * @returns boolean
 */
export const checkIsAmountLocked = (
  transaction: LockableTransaction | null | undefined,
): boolean => {
  if (!transaction) return false;
  return (
    (transaction.transaction_id !== null && transaction.transaction_id !== undefined) ||
    !!transaction.parent_transaction_uuid ||
    !!transaction.has_splits
  );
};

// Retrigger Vercel build
